import { CurrencyPipe } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import {
  AbstractControl,
  ControlContainer,
  FormArray,
  FormBuilder,
  FormControl,
} from "@angular/forms";
import { ModaleDatiContabiliComponent } from "@app/gestione-atti/modale-dati-contabili/modale-ricerca-conti/modale-dati-contabili.component";
import { TipologiaDecretoEnum } from "@app/shared/enum/tipologia-decreto-enum";
import { AttoService } from "@app/shared/services/atto.service";
import { ContoVO } from "@app/shared/vo/contoVO";
import { DatiContabiliVO } from "@app/shared/vo/dati-contabiliVO";

@Component({
  selector: "app-voci-bilancio",
  templateUrl: "./voci-bilancio.component.html",
})
export class VociBilancioComponent implements OnInit {
  public parentForm: AbstractControl;
  vociBilancio;
  tipologiaDecreto;
  anni: number[];

  isCollapsed = true;
  listaConti: ContoVO[];
  listaContiCopia: ContoVO[];
  messages = {
    emptyMessage: "Nessun conto",
    totalMessage: "totali",
  };
  datiContabiliFormArray: FormArray;
  indiceModifica: number;
  @ViewChild("appModaleDatiContabili", { static: false })
  modaleDatiContabili: ModaleDatiContabiliComponent;
  contoSelected: ContoVO;
  disabledAggiungi = true;
  TipologiaDecretoEnum = TipologiaDecretoEnum;
  constructor(
    private controlContainer: ControlContainer,
    private attoService: AttoService,
    private fb: FormBuilder,
    private currencyPipe: CurrencyPipe
  ) {
    this.disabledAggiungi = true;
  }

  ngOnInit() {
    this.parentForm = this.controlContainer.control;
    this.vociBilancio = this.parentForm.get("vociBilancio");

    this.tipologiaDecreto = this.parentForm.get("tipologiaDecreto");
    this.vociBilancio
      .get("completaDatiContabiliForm.dataInizio")
      .valueChanges.subscribe((dataInizio) => {
        console.log("annooooo inizio", new Date(dataInizio).getFullYear());
        if (
          new Date(dataInizio).getFullYear() !=
          new Date(
            this.vociBilancio.get("completaDatiContabiliForm.dataFine").value
          ).getFullYear()
        ) {
          this.vociBilancio
            .get("completaDatiContabiliForm.dataInizio")
            .setErrors({
              dateInvalide: true,
            });
          this.vociBilancio
            .get("completaDatiContabiliForm.dataFine")
            .setErrors({
              dateInvalide: true,
            });
        } else {
          this.vociBilancio
            .get("completaDatiContabiliForm.dataInizio")
            .setErrors(null);
          this.vociBilancio
            .get("completaDatiContabiliForm.dataFine")
            .setErrors(null);
        }
      });
    this.vociBilancio
      .get("completaDatiContabiliForm.dataFine")
      .valueChanges.subscribe((dataFine) => {
        console.log("annooooo fine", new Date(dataFine).getFullYear());
        if (
          new Date(dataFine).getFullYear() !=
          new Date(
            this.vociBilancio.get("completaDatiContabiliForm.dataInizio").value
          ).getFullYear()
        ) {
          this.vociBilancio
            .get("completaDatiContabiliForm.dataInizio")
            .setErrors({
              dateInvalide: true,
            });
          this.vociBilancio
            .get("completaDatiContabiliForm.dataFine")
            .setErrors({
              dateInvalide: true,
            });
        } else {
          this.vociBilancio
            .get("completaDatiContabiliForm.dataInizio")
            .setErrors(null);
          this.vociBilancio
            .get("completaDatiContabiliForm.dataFine")
            .setErrors(null);
        }
      });
    this.datiContabiliFormArray = this.vociBilancio.get(
      "datiContabili"
    ) as FormArray;
  }

  collapsed(): void {
    console.log(this.isCollapsed);
    this.isCollapsed = !this.isCollapsed;
    if (!this.isCollapsed) {
      this.vociBilancio.get("esercizio").setValue(new Date().getFullYear());

      this.anni = [];
      for (let index = 0; index < 4; index++) {
        const anno = this.vociBilancio.get("esercizio").value + index;
        this.anni.push(anno);
      }
      this.ricercaConti();
    }
  }

  disabled(item: ContoVO) {
    if (
      this.datiContabiliFormArray.value.findIndex(
        (res) =>
          res.conto == item.conto &&
          res.esercizio === this.vociBilancio.get("esercizio").value
      ) !== -1
    ) {
      return true;
    }
  }

  modificaDatiContabili(item: ContoVO) {
    this.contoSelected = item;
    this.vociBilancio
      .get("completaDatiContabiliForm.capienzaFormatted")
      .setValue(
        this.currencyPipe.transform(
          item.capienza,
          "EUR",
          true,
          "1.2-2",
          "it-IT"
        )
      );
    this.vociBilancio
      .get("completaDatiContabiliForm.capienza")
      .setValue(item.capienza);

    this.vociBilancio
      .get("completaDatiContabiliForm.residuoFormatted")
      .setValue(
        this.currencyPipe.transform(item.residuo, "EUR", true, "1.2-2", "it-IT")
      );
    this.vociBilancio
      .get("completaDatiContabiliForm.residuo")
      .setValue(item.residuo);

    this.vociBilancio.get("completaDatiContabiliForm.importo").setValue(0);
    this.vociBilancio
      .get("completaDatiContabiliForm.dataInizio")
      .setValue(new Date(this.vociBilancio.get("esercizio").value, 0));
    this.vociBilancio
      .get("completaDatiContabiliForm.dataFine")
      .setValue(
        new Date(this.vociBilancio.get("esercizio").value, 11, 31),
        "dd/MM/yyyy"
      );

    this.modaleDatiContabili.openModal();
  }

  valorizzaConto(conto: DatiContabiliVO) {
    console.log("valorizzaConto", this.contoSelected);
    this.disabledAggiungi = false;
    this.datiContabiliFormArray.insert(
      this.datiContabiliFormArray.length,
      this.fb.group({
        voceBilancio: new FormControl(conto.voceBilancio),
        area: new FormControl(this.contoSelected.area),
        capienza: new FormControl(this.contoSelected.capienza),
        residuo: new FormControl(this.contoSelected.residuo),
        importo: new FormControl(conto.importo),
        periodo: new FormControl(this.vociBilancio.get("periodo").value),
        esercizio: new FormControl(this.vociBilancio.get("esercizio").value),
        dataInizio: new FormControl(conto.dataInizio),
        dataFine: new FormControl(conto.dataFine),
      })
    );
  }

  ricercaConti() {
    console.log("ricercaConti");
    this.attoService
      .getListaContiCapienza(
        this.vociBilancio.get("esercizio").value,
        this.vociBilancio.get("periodo").value,
        null,
        null
      )
      .subscribe(
        (res) => {
          this.listaConti = res.conti;
          this.listaContiCopia = this.listaConti;
        },
        (err) => {}
      );
  }

  aggiungiDatiContabili() {
    this.vociBilancio
      .get("completaDatiContabiliForm.importo")
      .updateValueAndValidity({ emitEvent: true });
    this.vociBilancio
      .get("voceBilancio")
      .updateValueAndValidity({ emitEvent: true });
    if (this.indiceModifica != null) {
      this.datiContabiliFormArray
        .at(this.indiceModifica)
        .get("importo")
        .setValue(
          this.vociBilancio.get("completaDatiContabiliForm.importo").value
        );
      this.datiContabiliFormArray
        .at(this.indiceModifica)
        .get("residuo")
        .setValue(
          this.vociBilancio.get("completaDatiContabiliForm.residuo").value
        );
      this.datiContabiliFormArray
        .at(this.indiceModifica)
        .get("dataInizio")
        .setValue(
          this.vociBilancio.get("completaDatiContabiliForm.dataInizio").value
        );
      this.datiContabiliFormArray
        .at(this.indiceModifica)
        .get("dataFine")
        .setValue(
          this.vociBilancio.get("completaDatiContabiliForm.dataFine").value
        );
      this.indiceModifica = null;
    } else {
      this.datiContabiliFormArray.insert(
        this.datiContabiliFormArray.length,
        this.fb.group({
          voceBilancio: new FormControl(this.contoSelected.descrizione),
          area: new FormControl(this.contoSelected.area),
          capienza: new FormControl(this.contoSelected.capienza),
          residuo: new FormControl(this.contoSelected.residuo),
          conto: new FormControl(this.contoSelected.conto),
          periodo: new FormControl(this.vociBilancio.get("periodo").value),
          esercizio: new FormControl(this.vociBilancio.get("esercizio").value),
          importo: new FormControl(
            this.vociBilancio.get("completaDatiContabiliForm.importo").value
          ),
          dataInizio: new FormControl(
            this.vociBilancio.get("completaDatiContabiliForm.dataInizio").value
          ),
          dataFine: new FormControl(
            this.vociBilancio.get("completaDatiContabiliForm.dataFine").value
          ),
        })
      );
    }

    this.vociBilancio.get("completaDatiContabiliForm.importo").reset();
    this.vociBilancio.get("voceBilancio").reset();
  }

  updateFilter(event) {
    const val = event.target.value.toLowerCase();

    // filter our data
    const temp = this.listaContiCopia.filter(function(d) {
      return (
        d.conto.toString().indexOf(val) !== -1 ||
        d.descrizione.toLowerCase().indexOf(val) !== -1 ||
        !val
      );
    });

    // update the rows
    this.listaConti = temp;
    // Whenever the filter changes, always go back to the first page
    //   this.table.offset = 0;
  }

  modificaDatoContabile(i: number) {
    this.indiceModifica = i;
    let dati: DatiContabiliVO = this.datiContabiliFormArray.at(i).value;
    this.vociBilancio
      .get("completaDatiContabiliForm.importo")
      .setValue(this.datiContabiliFormArray.at(i).value.importo);
    this.vociBilancio
      .get("completaDatiContabiliForm.residuo")
      .setValue(this.datiContabiliFormArray.at(i).value.residuo);
    this.vociBilancio
      .get("completaDatiContabiliForm.residuoFormatted")
      .setValue(
        this.currencyPipe.transform(
          this.datiContabiliFormArray.at(i).value.residuo,
          "EUR",
          true,
          "1.2-2",
          "it-IT"
        )
      );

    this.vociBilancio
      .get("completaDatiContabiliForm.dataInizio")
      .setValue(new Date(this.datiContabiliFormArray.at(i).value.dataInizio));
    this.vociBilancio
      .get("completaDatiContabiliForm.dataFine")
      .setValue(new Date(this.datiContabiliFormArray.at(i).value.dataFine));

    this.modaleDatiContabili.openModal();
  }

  rimuoviDatoContabile(i: number) {
    this.datiContabiliFormArray.removeAt(i);
  }
}
